export const questionnaire1Questions = [
  {
    id: 'businessInterests_1',
    
    question:
      'Do you hold any directorship/ sole proprietorship/ partnership/ other business interests in any entity in Singapore or elsewhere?',
    inputLabel:
    'If Yes, please specify the total numbers of entities:',
    hasAttachment: true,
  },
   {
    id: 'businessInterests_2',

    question:
      'Do you have any shareholdings/ownership/partnership (excluding Sole Proprietorship) where 1% or more of the shareholdings are held by you in any entity in Singapore or elsewhere ?',
    inputLabel:
    'If Yes, please specify the total numbers of entities:',
    hasAttachment: true,
  },
   {
    id: 'businessInterests_5',

    question:
      'Has there been any changes/updates to your business activities since the last update to Company?',
    inputLabel:
    'If Yes, please specify the date Company has been informed of what was/were the change(s)?',
    hasAttachment: true,
  },
   {
    id: 'businessInterests_6',

    question:
      'Does any of your directorship/ sole proprietorship/ partnership/ other business interests in any entity in Singapore or elsewhere has a Beneficial Ownership (BO)* of another entity(ies)',
      note:
      'Beneficial Owner refers to any individual who exercises control over an entity and/or hold any percentage of the ownership interest in an entity whether directly or indirectly. ',
    inputLabel:
    'If Yes, please specify the name of the entity(ies) you are the beneficial owner of.',
    hasAttachment: true,
  },
   {
    id: 'businessInterests_3',

    question:
      'Does any of your connected persons* hold any directorship/ sole proprietorship/ partnership/ other business interests in any entity in Singapore or elsewhere which has business activities with PIAS?',
    inputLabel:
    'If Yes, please specify the name of entities:',
    hasAttachment: true,
  },
   {
    id: 'businessInterests_4',

    question:
      'Does any of your connected persons* have any shareholdings where 1% or more of the shareholdings are held by them in any entity in Singapore or elsewhere which has business activities with PIAS?',
    inputLabel:
    'If Yes, please specify the name of entities:',
    hasAttachment: true,
  },
 
  
];